<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-spacer />
              <v-col
                cols="12"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="yearFilter"
                  clearable
                  :items="years"
                  label="Year Filter"
                  placeholder="Filter by year"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-data-table
            :headers="headers"
            :loading="tableLoading"
            :search="search"
            :items="filteredTaxRate"
          >
            <template v-slot:item.chargeable_income_from="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.chargeable_income_from) }}
                </span>
              </div>
            </template>

            <template v-slot:item.chargeable_income_to="{ item }">
              <div>
                <span>
                  {{ item.chargeable_income_to == '2147483647'? 'Infinity' :currencyFormatting(item.chargeable_income_to) }}  
                </span>
              </div>
            </template>

            <template v-slot:item.tax_amount="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.tax_amount) }}
                </span>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        tableLoading: false,
        yearFilter: (new Date()).getFullYear(),
        years: [],   
        search: '',
        taxRates: [],
        headers: [
          {
            text: 'From (RM)',
            align: 'right',
            value: 'chargeable_income_from',
            sortable: false,
          },
          {
            text: 'To (RM)',
            align: 'right',
            value: 'chargeable_income_to',
            sortable: false,
          },
          {
            text: 'Tax Amount (RM)',
            align: 'right',
            value: 'tax_amount',
            sortable: false,
          },
          {
            text: 'Rate on Excess (%)',
            align: 'center',
            value: 'rate_on_excess',
            sortable: false,
          },
         
        ],
      }
    },
    computed: {
      filteredTaxRate () {
        return this.taxRates.filter(rate => rate.year === this.yearFilter)
      },
    },
    created () {
      this.loadTaxRate()
    },  
    methods: {     
      loadTaxRate () {
        this.tableLoading = true

        Promise.all([
          this.$api.taxRate().listTaxRateYear(),
          this.$api.taxRate().list(),
        ])
          .then(([year, taxRate]) => {
            this.years = year.data 
            this.taxRates = _.orderBy(taxRate.data, ['wages_from'], ['asc'])      

            this.tableLoading = false
          })
      },

      currencyFormatting (item) {
        return (Math.round((item / 100) * 100) / 100).toFixed(2)
      },

    },
  }
</script>
